import { useEffect, useState } from "react";

export interface Recent {
  q: string;
  title?: string;
  thumbUrl?: string;
}

interface Props {
  onSearch: (q: string) => void;
  recents?: Recent[];
}

export function Home({ onSearch, recents = [] }: Props) {
  const [q, setQ] = useState("");
  useEffect(() => {
    document.getElementById("home-search")?.focus();
  }, []);
  return (
    <main className="home" lang="en">
      <h1>no.website</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (q.trim()) onSearch(q.trim());
        }}
      >
        <label htmlFor="home-search" className="visually-hidden">
          Search
        </label>
        <input
          id="home-search"
          type="search"
          autoComplete="off"
          inputMode="search"
          placeholder="Search anything"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          aria-label="Search no.website"
        />
        <button type="submit" aria-label="Look up">
          Look up
        </button>
      </form>
      {recents.length > 0 && (
        <nav className="recents" aria-label="Recent look ups">
          {recents.map((r) => (
            <a
              key={r.q}
              href={`?q=${encodeURIComponent(r.q)}`}
              className="recent-chip"
              onClick={(e) => {
                e.preventDefault();
                onSearch(r.q);
              }}
            >
              {r.thumbUrl ? (
                <img
                  className="recent-thumb"
                  src={r.thumbUrl}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <span className="recent-thumb recent-thumb-placeholder" aria-hidden="true">
                  {(r.title ?? r.q).slice(0, 1).toUpperCase()}
                </span>
              )}
              <span className="recent-label">{r.title ?? r.q}</span>
            </a>
          ))}
        </nav>
      )}
    </main>
  );
}
